export class DateRange {
    public dateFrom: string;
    public dateTo: string;
}
